if (!customElements.get('recipe-rail-count')) {
  customElements.define(
    'recipe-rail-count',
    class RecipeRailCount extends HTMLElement {
      abortController = undefined;

      connectedCallback() {
        if (!this.hidden) {
          return;
        }

        this.fetchCount();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get valueElement() {
        return this.querySelector('[data-recipe-count-value]');
      }

      async fetchCount() {
        this.abortController?.abort();
        this.abortController = new AbortController();

        try {
          // article-tag-count owns the only paginate for this total. Paginating
          // inside recipe-rail would replace the blog feed's pagination.
          // Built through URL so an existing query string keeps section_id.
          const endpoint = new URL(this.dataset.url, window.location.origin);
          endpoint.searchParams.set('section_id', 'article-tag-count');

          const response = await fetch(endpoint, {
            signal: this.abortController.signal,
          });

          if (!response.ok) {
            return;
          }

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const count = Number(html.querySelector('[data-tagged-article-count]')?.dataset.taggedArticleCount);

          if (!count) {
            return;
          }

          this.render(count);
        } catch {
          // A count that cannot be fetched stays hidden rather than guessed.
        }
      }

      /**
       * @param {number} count - Number of articles carrying the recipe tag
       */
      render(count) {
        const pluralCategory = new Intl.PluralRules(document.documentElement.lang || undefined).select(count);
        const template = pluralCategory === 'one' ? this.dataset.labelOne : this.dataset.labelOther;

        this.valueElement.textContent = template.replace('[count]', count.toLocaleString());
        this.hidden = false;
      }
    },
  );
}
